import { render, staticRenderFns } from "./CreateBookingView.vue?vue&type=template&id=19cd304c&scoped=true"
import script from "./CreateBookingView.vue?vue&type=script&lang=ts"
export * from "./CreateBookingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd304c",
  null
  
)

export default component.exports